import React from "react";
import headerCSS from "./footer.module.css";
import { useTranslation } from 'react-i18next';
import { t } from "i18next";

import { Layout, Row, Col, Typography } from "antd";
const { Footer } = Layout;
const { Text, Title } = Typography;
export interface IWebHeader {
  theme: "light" | "dark";
  className?: string;
  short?: boolean;
}

export const WebHeader: React.FunctionComponent<IWebHeader> = (prop) => {
  const { theme, short } = prop;
  //const key = useAppSelector((state) => state.user.key);

  return (
    <Footer
      className={`${headerCSS.navHeader} ${theme === "dark" ? headerCSS.navDark : headerCSS.navLight
        } ${prop.className ? prop.className : ""}`}
        style={{minWidth:"1200px"}}
    >
      <Row justify="center" gutter={2} style={{ paddingTop: 53 }} align="middle">
        {(short) || (<>
          <Col style={{ textAlign: "left" }}>
            <div style={{ width: 350 }}>
              <Title
                level={4}
                className={`${theme === "dark" ? headerCSS.navDark : headerCSS.navLight}`}
              >
                {t("举办单位")}
              </Title>
              <Text className={`${theme === "dark" ? headerCSS.navDark : headerCSS.navLight}`}>
                深圳市科技创新委员会<br /><br />
                鹏城实验室<br /><br />
                新一代人工智能产业技术创新战略联盟 (AITISA)
              </Text>
              {/* <Title
                level={5}
                className={`${theme === "dark" ? headerCSS.navDark : headerCSS.navLight}`}
              >
                独家钻石协办单位
              </Title>
              <Text className={`${theme === "dark" ? headerCSS.navDark : headerCSS.navLight}`}>
                单位H
              </Text> */}

            </div>

          </Col>
          <Col style={{ textAlign: "left" }}>
            <div style={{ width: 300 }}>
              <Title
                level={4}
                className={`${theme === "dark" ? headerCSS.navDark : headerCSS.navLight}`}
              >
                {t("协办单位")}
              </Title>
              <Text className={`${theme === "dark" ? headerCSS.navDark : headerCSS.navLight}`}>
                华为技术有限公司<br /><br />
                中国工商银行股份有限公司深圳市分行<br /><br />
                中国农业银行股份有限公司深圳市分行<br />
              </Text>
              {/*<Title
                level={5}
                className={`${theme === "dark" ? headerCSS.navDark : headerCSS.navLight}`}
              >
                {/ * 赞助单位 * /}
                <br />
              </Title>
              <Text className={`${theme === "dark" ? headerCSS.navDark : headerCSS.navLight}`}>
                <br />
                {/  单位X * /}
              </Text>*/}

            </div>

          </Col>
          <Col style={{ textAlign: "left" }}>
            <div style={{ width: 300 }}>
              <Title
                level={4}
                className={`${theme === "dark" ? headerCSS.navDark : headerCSS.navLight}`}
              >
                {/*t("协办单位")*/}
              </Title>
              <Text className={`${theme === "dark" ? headerCSS.navDark : headerCSS.navLight}`}>
                中国建设银行股份有限公司深圳市分行<br /><br />
                深圳市鹏城实验室科教基金会<br />
              </Text>
              {/*<Title
                level={5}
                className={`${theme === "dark" ? headerCSS.navDark : headerCSS.navLight}`}
              >
                {/ * 赞助单位 * /}
                <br />
              </Title>
              <Text className={`${theme === "dark" ? headerCSS.navDark : headerCSS.navLight}`}>
                <br />
                {/  单位X * /}
              </Text>*/}

            </div>

          </Col>          
        </>)
        }
        <Col style={{ textAlign: "center" }}>
          <div >
            <Title
              level={4}
              className={`${theme === "dark" ? headerCSS.navDark : headerCSS.navLight}`}
            >
              {t("关注公众号，了解更多")}
            </Title>
            <img
              style={{ marginTop: 10, height: 120, width: 120 }}
              referrerPolicy="no-referrer"
              src="https://naic.pcl.ac.cn/qrcode.jpg"
              alt="qrcode"
            />
          </div>
        </Col>

        <Col span={24} style={{ textAlign: "center", padding: "30px 0" }}>
          <div style={{ marginTop: 40 }}>
            <Text
              className={`${theme === "dark" ? headerCSS.navDark : headerCSS.navLight}`}
            >
              {"办赛联系方式："}<a href="mailto:naic@pcl.ac.cn"> naic@pcl.ac.cn</a>
            </Text>
            <br />
            <Text
              className={`${theme === "dark" ? headerCSS.navDark : headerCSS.navLight}`}
            >
              {"Copyright 2021 鹏城实验室. All Right Reserved. "}
            </Text>
            <br />
            <Text
              className={`${theme === "dark" ? headerCSS.navDark : headerCSS.navLight}`}
            >
              {"备案号："}<a href="https://beian.miit.gov.cn">粤ICP备 18066427号</a>
            </Text>
          </div></Col>
      </Row>
    </Footer>
  );
};

export default WebHeader;
